import { render } from "./customMade.vue?vue&type=template&id=2a751e64&scoped=true&bindings={\"navId\":\"data\",\"topImg\":\"data\",\"playImg\":\"data\",\"midMainBox\":\"data\",\"imgList\":\"data\",\"midmain2bottom\":\"data\"}"
import script from "./customMade.vue?vue&type=script&lang=js"
export * from "./customMade.vue?vue&type=script&lang=js"

import "./customMade.vue?vue&type=style&index=0&id=2a751e64&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-2a751e64"

export default script